import { useEffect, useState, useMemo, useRef, useLayoutEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  APP_COLOR,
  BLUETOOTH_PORT,
  COLOR_WHITE,
  ENTERNET_PORT,
  LINEAR_GRADIENT_BG,
  SHOP_SETTING_KEY,
  USB_PORT,
  USER_KEY,
} from "../../../const";
import html2canvas from "html2canvas";
import moment from "moment";
import axios from "axios";
import React from "react";

// component
import { errorSwal, successUpdateSwal } from "../../../helper/sweetalert";
import AnimationLoading from "../../../components/Animationloading";
import BillforSale80 from "../../../components/bill/BillforSale80";
import {
  calculateTotalPaid,
  // calculateTotalPrice,
  // convertCurrency,
  convertOrderStatus,
  // covertTimeZone,
  numberFormat,
} from "../../../helper";
import CustomButton from "../../../components/CustomButton";
import { base64ToBlob } from "../../../helper";
import Swal from "sweetalert2";

// bootrap
import { Form, Modal, Spinner, Table, Row, Col } from "react-bootstrap";
import "../OfferHistory.css";

// apollo
import {
  RETURN_ORDER_GROUP,
  UPDATE_ORDER_GROUP,
  UPDATE_ORDER_GROUP_V2,
  UPDATE_PAID,
} from "../../../apollo/ordergroup/mutation";
import { GET_ORDERGROUP } from "../../../apollo/ordergroup/query";
import { GET_PRINTERS } from "../../../apollo/printer/Query";
import { useLazyQuery, useMutation } from "@apollo/client";

// icons
import {
  // MdClose,
  // MdMoney,
  // MdOutlineArrowBack,
  // MdOutlinePaid,
  MdOutlineQuestionMark,
  MdSettingsBackupRestore,
} from "react-icons/md";
// import { MdOutlineMoneyOff } from "react-icons/md";
import { AiFillEdit } from "react-icons/ai";
import PrintIcon from "@mui/icons-material/Print";
// import { FaCheckDouble } from "react-icons/fa";
import { MdAttachMoney } from "react-icons/md";
import ReactToPrint from "react-to-print";
import ComfirmModal from "../../../components/ComfirmModal";
// import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import { GET_EXCHANGE_RATE } from "../../../apollo/product/query";
import { GET_SHOP } from "../../../apollo/shop/Query";
// import { GET_EXCHANGRATE } from "../../../apollo/exchangeRate/Query";
import useWindowDimensions from "../../../helper/windowDimensions";
import { useSelector } from "react-redux";
import BillOfferPriceV2 from "../../../components/bill/BillOfferPriceV2";
import BillOfferPriceV3 from "../../../components/bill/BillOfferPriceV3";
import BillOrderDetailA4V2 from "../../../components/bill/BillOrderDetailA4V2";
import { FaCheck } from "react-icons/fa";

export default function SaleHistoryDetail() {
  const history = useHistory();
  const Location = useLocation();
  let bill80Ref = useRef(null);
  let bill58Ref = useRef(null);
  let componentRef = useRef();
  const { width } = useWindowDimensions()

  //Memo
  const orderGroup = useMemo(() => Location?.state?.state, [Location?.state?.state]);

  const [ordergroup, setOrderGroup] = useState([]);
  // console.log("ordergroup: ", ordergroup);
  const shopIdPrinter = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
    ?.id;
  const shopSetting = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY));

  const [printer, setPrinter] = useState();
  const [widthBill80, setWidthBill80] = useState(0);
  const [widthBill58, setWidthBill58] = useState(0);
  const [dataForRetrun, setDataForRetrun] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showConfirmReturnOrder, setShowConfirmReturnOrder] = useState(false);
  const [showComfirmReturnAll, setShowComfirmReturnAll] = useState(false);

  const [showUpdatePaid, setShowUpdatePaid] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [preAmount, setPreAmount] = useState("");
  // const [prePrice, setPrePrice] = useState("");
  // const [prePriceBaht, setPrePriceBaht] = useState("");
  // const [prePriceUsd, setPrePriceUsd] = useState("");
  const [shopData, setShopData] = useState();
  const [userData, setUserData] = useState()
  const [exchangeRate, setExchangeRate] = useState([]);
  const [prepareRate, setPrepareRate] = useState();
  const [isBillOfferPrice, setIsBillOfferPrice] = useState("BILL_OFFPRICE_V1");
  const [orderStatus, setOrderStatus] = useState(null)

  // get permission from redux
  const { rolePermissions } = useSelector((state) => state.permissions);

  const [
    getExchangeRate,
    { data: exchangeRateData, loading: exchangeRateLoading },
  ] = useLazyQuery(GET_EXCHANGE_RATE, {
    fetchPolicy: "cache-and-network",
  });

  const [loadorder, { data: getorder, loading }] = useLazyQuery(
    GET_ORDERGROUP,
    { fetchPolicy: "cache-and-network" }
  );
  const [getPrinterDatas, { data: printerDatas, loading: printerLoading }] =
    useLazyQuery(GET_PRINTERS, { fetchPolicy: "cache-and-network" });

  const [returnordergroup, { loading: loadingreturnordergroup }] =
    useMutation(RETURN_ORDER_GROUP);

  // const [LoadExchangeRate, { data: GetExchangeRate }] = useLazyQuery(GET_EXCHANGRATE, { fetchPolicy: "network-only" });
  const [updatePaid, { loading: loadingUpdatePaid }] = useMutation(UPDATE_PAID);

  const [updateOrdergroup, { loading: ordergroupLoadding }] = useMutation(UPDATE_ORDER_GROUP);
  const [confirmShippingOrder, { loading: confirmShippLoading }] = useMutation(UPDATE_ORDER_GROUP_V2);

  const [loadShop, { data: loadShopData, loading: loadingShop }] = useLazyQuery(
    GET_SHOP,
    {
      fetchPolicy: "network-only",
    }
  );

  // culalate price to baht and usd
  // const sumPrice = Location?.state?.state?.sumPrice ?? 0;
  // const currency = Location?.state?.state?.currency;

  useEffect(() => {

    if (exchangeRateData) {
      setPrepareRate(exchangeRateData?.exchangeRate)
    }

  }, [exchangeRateData])

  useEffect(() => {
    let localShopData = JSON.parse(localStorage.getItem("SHOP_DATA"));
    let localUserData = JSON.parse(localStorage.getItem("USER_DATA"))
    const shopSettingData = JSON.parse(localStorage.getItem("SHOP_SETTING_DATA"));
    setIsBillOfferPrice(shopSettingData?.isBillOfferPrice);

    getExchangeRate({
      variables: {
        where: {
          shop: localShopData?.id,
        },
      },
    });

    // get role from user data
    if (localUserData) {
      setUserData(localUserData?.data)
    }
  }, []);

  useEffect(() => {
    // const _totalPriceNew = dataForRetrun.reduce(
    //   (acc, order) => acc + order.totalPrice,
    //   0
    // );
    // const _priceBaht = dataForRetrun.reduce(
    //   (acc, order) => acc + order.totalPriceBaht,
    //   0
    // );
    // const _priceUsd = dataForRetrun.reduce(
    //   (acc, order) => acc + order.totalPriceUsd,
    //   0
    // );
    const _amountNew = dataForRetrun.reduce(
      (acc, order) => acc + order.amount,
      0
    );

    // setPrePriceBaht(_priceBaht);
    // setPrePriceUsd(_priceUsd);
    // setPrePrice(_totalPriceNew);
    setPreAmount(_amountNew);
  }, [dataForRetrun]);

  useEffect(() => {
    if (loadShopData) {
      setShopData(loadShopData?.shop);
    }
  }, [loadShopData]);

  useEffect(() => {
    _fetchorder();
    _fetchPrinter();
  }, []);

  useEffect(() => {
    if (getorder) {
      setOrderGroup(getorder?.orderGroup?.orders);
      setOrderStatus(getorder?.orderGroup?.status)
    }
  }, [getorder]);

  useEffect(() => {
    if (printerDatas) setPrinter(printerDatas?.printers?.data);
  }, [printerDatas]);

  // useEffect(() => {
  //   // setOrderGroupData(Location?.state?.state);
  // }, []);

  useEffect(() => {
    _fetchShop();
  }, [shopIdPrinter]);

  const _fetchShop = () => {
    loadShop({
      variables: {
        where: {
          id: shopIdPrinter,
        },
      },
    });
  };

  const _fetchorder = async () => {
    await loadorder({
      variables: {
        where: {
          id: Location?.state?.state?.id,
        },
      },
    });
  };

  const _fetchPrinter = async () => {
    await getPrinterDatas({
      variables: {
        where: {
          shop: shopIdPrinter,
          isDeleted: false,
        },
      },
    });
  };


  const convertCurrency = (amount, fromCurrency, toCurrency) => {
    const rateFrom = exchangeRate.find(rate => rate.currency === fromCurrency)?.exchangeRate || 1;
    const rateTo = exchangeRate.find(rate => rate.currency === toCurrency)?.exchangeRate || 1;
    return (amount / rateFrom) * rateTo;
  };

  const calculateTotalPrice = (currency, order) => {
    const totalPriceInKip = order.totalPrice;
    switch (currency) {
      case "ບາດ":
        return convertCurrency(totalPriceInKip, 'ກີບ', 'ບາດ');
      case "ໂດລາ":
        return convertCurrency(totalPriceInKip, 'ກີບ', 'ໂດລາ');
      case "ກີບ":
      default:
        return totalPriceInKip;
    }
  };

  const calculateSumKipFromOrders = (orders = []) => {
    // ดึงค่า rate มาเตรียมไว้ก่อน โดยเช็คจาก getorder (API) ก่อน แล้วค่อยเช็คจาก Location (State)
    const rateBaht = parseFloat(getorder?.orderGroup?.rateBaht || Location?.state?.state?.rateBaht || 1);
    const rateUsd = parseFloat(getorder?.orderGroup?.rateUsd || Location?.state?.state?.rateUsd || 1);

    return orders.reduce((sum, order) => {
      const base = parseFloat(order?.totalPrice || 0);
      const cur = order?.currency || order?.stock?.currency;
      if (cur === "LAK" || cur === "ກີບ") return sum + base;
      // ใช้ตัวแปรที่ดึงมา
      if (cur === "BAHT" || cur === "ບາດ") return sum + base * rateBaht; 
      if (cur === "USD" || cur === "ໂດລາ") return sum + base * rateUsd;
      return sum + base;
    }, 0);
  };

  useLayoutEffect(() => {
    setWidthBill80(bill80Ref?.current?.offsetWidth);
    setWidthBill58(bill58Ref?.current?.offsetWidth);
  }, [bill80Ref, bill58Ref]);

  const onPrintBill = async () => {
    try {
      // ซ่อน checkbox ชั่วคราวก่อนแปลงเป็นภาพด้วย html2canvas
      const targetEl = bill80Ref.current || bill58Ref.current;
      const hiddenNodes = Array.from(targetEl?.querySelectorAll('input[type="checkbox"]') || []);
      hiddenNodes.forEach(node => node.style.display = 'none');

      let urlForPrinter = "";
      const _printerCounters = printer;
      const printerBillData = printer?.find((e) => e?.status === true);

      let dataImageForPrint;
      if (printerBillData?.width === "80mm") {
        dataImageForPrint = await html2canvas(bill80Ref.current, {
          useCORS: true,
          scrollX: 10,
          scrollY: 2,
          scale: 560 / widthBill80,
        });

      }

      if (printerBillData?.width === "58mm") {

        dataImageForPrint = await html2canvas(bill58Ref.current, {
          useCORS: true,
          scrollX: 10,
          scrollY: 0,
          scale: 350 / widthBill58,
        });
      }

      // แสดง checkbox กลับหลังจากสร้างภาพเสร็จ
      hiddenNodes.forEach(node => node.style.display = '');

      if (printerBillData?.type === "ETHERNET") {
        urlForPrinter = ENTERNET_PORT;
      }
      if (printerBillData?.type === "BLUETOOTH") {

        urlForPrinter = BLUETOOTH_PORT;
      }
      if (printerBillData?.type === "USB") {
        
        urlForPrinter = USB_PORT;
      }

      const _file = await base64ToBlob(dataImageForPrint.toDataURL());

      var bodyFormData = new FormData();
      bodyFormData.append("ip", printerBillData?.ip);
      bodyFormData.append("port", "9100");
      bodyFormData.append("image", _file);
      bodyFormData.append("beep1", 1);
      bodyFormData.append("beep2", 9);

      const res = await axios({
        method: "post",
        url: urlForPrinter,
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res?.status === 200) {
        // console.log("res logs: ", res)
        await Swal.fire({
          icon: "success",
          title: "ປິນສຳເລັດ",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (err) {
      await Swal.fire({
        icon: "error",
        title: "ປິນບໍ່ສຳເລັດ",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const _ReturnOrderGroup = async () => {
    try {
      if (loadingreturnordergroup) return;
      await returnordergroup({
        variables: {
          orderBy: "createdAt_DESC",
          where: {
            id: Location?.state?.state?.id,
          },
        },
      });
      successUpdateSwal("ສົ່ງຄືນສິນຄ້າສຳເລັດ");
      history.goBack();
    } catch (err) {
      errorSwal("ໄດ້ສົ່ງຄືນອໍເດີນີ້ເເລ້ວ");
    }
  };

  const _updateOrders = async () => {
    try {
      if (ordergroupLoadding) return;

      const { orders, orderGroup } = Location?.state?.state;
      const orderIds = await dataForRetrun.map((order) => order.id);

      const filteredOrders = await orders.reduce((acc, order) => {
        if (!orderIds.includes(order.id)) {
          acc.push(order);
        }
        return acc;
      }, []);

      const normalizeChildren = (children) =>
        (children || []).map((child) => {
          const { __typename, stock, ...childRest } = child || {};
          return {
            ...childRest,
            stock: child?.stock?.id ? child.stock : stock,
          };
        });

      const _newOrders = await filteredOrders.map((order) => {
        const {
          __typename,
          phone,
          totalPriceBaht,
          totalPriceUsd,
          type,
          product,
          isDeleted,
          isPaymented,
          note,
          category,
          ...rest
        } = order;
        return {
          ...rest,
          stock: order?.stock?.id ?? order?.product,
          children: normalizeChildren(order?.children),
        };
      });

      const _dataSelects = await dataForRetrun.map((order) => {
        const {
          __typename,
          phone,
          totalPriceBaht,
          totalPriceUsd,
          type,
          product,
          isDeleted,
          isPaymented,
          note,
          category,
          ...rest
        } = order;
        return {
          ...rest,
          stock: order?.stock?.id ?? order?.product,
          children: normalizeChildren(order?.children),
        };
      });

      const _priceBahtNew = dataForRetrun.reduce(
        (sum, order) => sum + calculateTotalPrice("ບາດ", order),
        0
      );
      const _priceUsdNew = dataForRetrun.reduce(
        (sum, order) => sum + calculateTotalPrice("ໂດລາ", order),
        0
      );
      const _priceKipNew = dataForRetrun.reduce(
        (sum, order) => sum + calculateTotalPrice("ກີບ", order),
        0
      );

      let sumPriceLAK = 0;
      let sumPriceBaht = 0;
      let sumPriceUsd = 0;

      _newOrders?.map((order) => {
        const price = order.price * order.amount;

        switch (order?.currency) {
          case "LAK":
          case "ກີບ":
            sumPriceLAK += price;
            break;
          case "BAHT":
          case "ບາດ":
            sumPriceBaht += price * prepareRate?.baht;
            break;
          case "USD":
          case "ໂດລາ":
            sumPriceUsd += price * prepareRate?.usd;
            break;
          default:
        }

        return null;
      });

      await updateOrdergroup({
        variables: {
          where: {
            id: Location?.state?.state?.id,
          },
          data: {
            amount: Location?.state?.state?.amount - preAmount,
            sumPrice: sumPriceUsd + sumPriceBaht + sumPriceLAK,
            totalPrice: Location?.state?.state?.totalPrice - _priceKipNew,
            sumPriceBaht: Location?.state?.state?.sumPriceBaht - _priceBahtNew,
            sumPriceUsd: Location?.state?.state?.sumPriceUsd - _priceUsdNew,
            receivedMoney: Location?.state?.state?.receivedMoney,
            currency: Location?.state?.state?.currency ?? "LAK",
            rateBaht:Location?.state?.state?.rateBaht || 1,
            rateUsd:Location?.state?.state?.rateUsd || 1,
            status: isSelectAll ? "" : Location?.state?.state?.status,
            orders: _newOrders,
            dataSelect: _dataSelects,
          },
        },
      });

      history.goBack();
      successUpdateSwal("ສົ່ງຄືນສິນຄ້າສຳເລັດ");
    } catch (err) {
      errorSwal("ຜິດພາດກະລຸນາລອງໃຫມ່ອີກຄັ້ງ");
      console.log("error", err);
    }
  };

  // confirm shipping order group
  const handleConfirmShipped = async () => {
    try {
      if (confirmShippLoading) return;
      await confirmShippingOrder({
        variables: {
          where: {
            id: Location?.state?.state?.id,
          },
          data: {
            status: "SHIPPINGCOMPLETED",
          }
        }
      })
      _fetchorder();

    } catch (error) {
      console.log({ error })
    }
  }

  const _updatePaid = async () => {
    try {
      if (loadingUpdatePaid) return;
      await updatePaid({
        variables: {
          orderBy: "createdAt_DESC",
          where: {
            id: Location?.state?.state?.id,
          },
        },
      });

      successUpdateSwal("ຈ່າຍເງີນໃບບິນນີ້ສຳເລັດ");
      setShowUpdatePaid(false);
      history.goBack();
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const handleSelectAllItems = () => {
    if (isSelectAll) {
      setIsSelectAll(false);
      setDataForRetrun([]);
    } else {
      setIsSelectAll(true);
      // setDataForRetrun(ordergroupData?.orders);
      setDataForRetrun(orderGroup?.orders);
    }
  };

  const handleSelectSingleItems = (e) => {
    const orderId = e.id;

    setDataForRetrun((prevSelected) => {
      const isSelected = prevSelected.some((item) => item.id === orderId);

      if (isSelected) {
        return prevSelected.filter((item) => item.id !== orderId);
      } else {
        return [...prevSelected, e];
      }
    });
  };

  const handleSelectOrderChildren = (c) => {
    const orderId = c?.order;
    const orderChildId = c?.id;

    // setDataForRetrun((prevSelected) => {
    //   const isSelected = prevSelected.some((item) => item.id === orderId);

    //   if (isSelected) {
    //     return prevSelected.filter((item) => item.id !== orderId);
    //   } else {
    //     return [...prevSelected, c];
    //   }
    // });
  };

  // check role
  const isAdmin = userData?.role === "ADMIN";
  const hasEditBillPermission = ["EDIT_BILL"].some(permission => rolePermissions.includes(permission));
  return (
    <React.Fragment>
      <div className="offerpricehistory-detail-main-sale">
        {/* <BreadCrumbComponent
          goback={() => history.goBack()}
          txtFirst="ຂໍ້ມູນການຂາຍ"
          txtSecond={`ລາຍການ`}
        /> */}
        {loading && !getorder ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "50vh",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <AnimationLoading />
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: width > 700 ? "2em" : 5,
                flexDirection: 'column',
                position: "relative",
                paddingBottom: '8em'
              }}
            >

              <div
                style={{
                  width: "100%",
                  padding: "1em",
                  background: "#fff",
                }}
                ref={componentRef}
              >
                { isBillOfferPrice === "INVOICE_DETAIL_4" ? (
                  <BillOrderDetailA4V2 
                    orderGroup={getorder?.orderGroup || Location?.state?.state}
                    customername={getorder?.orderGroup?.customerName || Location?.state?.state?.customerName}
                    customerLastName={getorder?.orderGroup?.customerLastName || Location?.state?.state?.customerLastName}
                    phonenumber={getorder?.orderGroup?.phone || Location?.state?.state?.phone}
                    village={getorder?.orderGroup?.village || Location?.state?.state?.village}
                    district={getorder?.orderGroup?.district || Location?.state?.state?.district}
                    province={getorder?.orderGroup?.province || Location?.state?.state?.province}
                    // userconfirmName={Location?.state?.state?.staffLastname}
                    // userconfirmPhone={Location?.state?.state?.staffLastname}
                    activeTab={getorder?.orderGroup?.payment || Location?.state?.state?.payment}
                    shopData={shopData}
                  />
                ) : isBillOfferPrice === "BILL_OFFPRICE_V3" ? (
                  <BillOfferPriceV3 shopData={shopData} orderGroupData={getorder?.orderGroup || Location?.state?.state} orderStatus={orderStatus} titleBill="Invoice ໃບເກີບເງິນ" />
                ) : isBillOfferPrice === "BILL_OFFPRICE_V2" ? (
                  <BillOfferPriceV2 shopData={shopData} localOrder={getorder?.orderGroup || Location?.state?.state} orderStatus={orderStatus} titleBill="ໃບເກັບເງິນ (Invoice)" />
                ) : (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "center",
                      }}
                    >
                      <h2>{shopData?.name}</h2>
                      <p>
                        {shopData?.address?.village}, {shopData?.address?.district},{" "}
                        {shopData?.address?.province}
                      </p>
                      <p style={{ marginTop: "-1em" }}>{shopData?.phone}</p>
                      <h3 style={{ fontSize: "25px", fontweight: "bold" }}>
                        {/* <b>ໃບບິນເກັບເງິນ</b> */}
                        <b>ໃບບິນຮັບເງິນ</b>
                      </h3>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>ເລກທີບິນ: {Location?.state?.state.code}</div>

                      </div>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>ວັນທີ,ເດືອນ,ປີ:  {moment(Location?.state?.state?.checkBillDate ?? Location?.state?.state?.createdAt).format(
                          "DD/MM/YYYY HH:mm:ss"
                        )}</div>
                        <div>
                          <p>
                            {Location?.state?.state.payment === "CASH"
                              ? " [ ເງິນສົດ ]"
                              : " [ ເງິນໂອນ ]"}
                          </p>
                          <p>
                            {convertOrderStatus(Location?.state?.state.status)}
                          </p>
                        </div>
                      </div>

                      <div style={{
                        lineHeight: "10px",
                        marginTop: '-1.5em'
                      }}>
                        <p>
                          ລູກຄ້າ :{" "}
                          {Location?.state?.state?.customerName ??
                            "......................"}{" "}
                          {Location?.state?.state?.customerLastName ??
                            "..................."}{" "}
                        </p>
                        <p>
                          ທີ່ຢູ່ :{" "}
                          {Location?.state?.state?.village
                            ? Location?.state?.state?.village + ","
                            : ".............., "}
                          {Location?.state?.state?.district
                            ? Location?.state?.state?.district + ","
                            : ".............., "}
                          {Location?.state?.state?.province
                            ? Location?.state?.state?.province + ","
                            : ".............."}{" "}
                        </p>
                        <p>
                          ເບີໂທ :{" "}
                          {Location?.state?.state?.phone ??
                            "......................................."}{" "}
                        </p>

                        <Row>
                          <Col>
                            <p>
                              ພະນັກງານຂາຍ :{" "}
                              {Location?.state?.state?.staff ?? "..............."}{" "}
                              {Location?.state?.state?.staffLastname ??
                                "..............."}
                            </p>
                          </Col>
                          <Col>
                            <p>
                              ໝາຍເຫດ :{" "}
                              {Location?.state?.state?.note ?? "..............."}
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'left' }}>
                            {Location?.state?.state.status === "CANCELLED" ? (
                              <span>ລຳດັບ</span>
                            ) : (
                              <Form.Check
                                inline
                                label="ລຳດັບ"
                                type="checkbox"
                                checked={isSelectAll}
                                onClick={() => handleSelectAllItems()}
                              />
                            )}
                          </th>
                          <th>ລາຍການ</th>
                          <th>ຈຳນວນ</th>
                          <th>ຂະໜາດ</th>
                          <th>ແຖມ</th>
                          <th>ລາຄາ</th>
                          <th>ລວມ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* {ordergroupData?.orders?.slice() */}
                        {/* //*TABLE */}
                        {ordergroup?.slice()
                          .sort((a, b) => parseInt(a.sortId) - parseInt(b.sortId))
                          .map((e, index) => (
                            <>
                                <tr key={index}>
                                  <td style={{ minWidth: 100 }}>
                                    {Location?.state?.state?.status === "CANCELLED" ? (
                                      ""
                                    ) : (
                                      <>
                                        {isSelectAll ? (
                                          <Form.Check inline type="checkbox" checked={true} disabled />
                                        ) : (
                                          <Form.Check
                                            inline
                                            type="checkbox"
                                            onClick={() => handleSelectSingleItems(e)}
                                            checked={dataForRetrun.includes(e)}
                                          />
                                        )}
                                      </>
                                    )}
                                    {index + 1}
                                  </td>
                                  <td style={{ minWidth: 100 }}>{e?.productName}</td>
                                  <td style={{ minWidth: 100 }}>{e?.amount} {e?.stock?.unit ?? e?.stock?.unitId?.name ?? ""}</td>
                                  <td style={{ minWidth: 100 }}>{e?.stock?.size ?? ""}</td>
                                  <td style={{ minWidth: 100 }}>
                                    {(() => {
                                      const freeAmount = e?.children?.filter(c => c?.tag === "FREE").reduce((sum, c) => sum + (c?.amount || 0), 0) 
                                      // || e?.amountFree || 0;
                                      // return `${freeAmount} ${e?.stock?.unit ?? e?.stock?.unitId?.name ?? ""}`;
                                    })()}
                                  </td>
                                  <td style={{ minWidth: 100 }}>
                                    {((e) => {
                                      if (!e) return "Loading..."; // Handle undefined order                  
                                      const basePrice = parseInt(e?.price || 0);
                                      const optionPrice = (e?.options || []).reduce(
                                        (acc, item) => acc + (item?.price || 0),
                                        0
                                      );

                                      return `${numberFormat(basePrice + optionPrice)}`;
                                    })(e)} {/* Pass order as argument */}
                                    </td>
                                  <td style={{ minWidth: 100 }}>{numberFormat(e?.totalPrice)} {e?.currency === "BAHT" ? "ບາດ" : e?.currency}</td>
                                </tr>
                                {/* //* order children */}
                                <> 
                                  {
                                    e?.children.length > 0 ? 
                                    (
                                      e?.children.map((child, childIndex) => (
                                        <tr key={childIndex}>
                                          <td style={{ minWidth: 100, fontSize: 14 }} className="ps-4">
                                            {Location?.state?.state?.status === "CANCELLED" ? (
                                              ""
                                            ) : (
                                              <>
                                                {isSelectAll ? (
                                                  <Form.Check inline type="checkbox" checked={true} disabled />
                                                ) : (
                                                  <Form.Check
                                                    inline
                                                    type="checkbox"
                                                    onClick={() => handleSelectSingleItems(e)}
                                                    checked={dataForRetrun.includes(e)}
                                                  />
                                                )}
                                              </>
                                            )}
                                            ລາຍການແຖມ
                                          </td>
                                          <td style={{fontSize: 14}}>{child?.productName}</td>
                                          <td style={{fontSize: 14}}>
                                            {child?.amount ?? child?.volume} {child?.unit || child?.stock?.unitId?.name || child?.stock?.unit || e?.stock?.unitId?.name || e?.stock?.unit || ""}
                                          </td>
                                          <td style={{fontSize: 14}}>{child?.size || "-"}</td>
                                          <td style={{fontSize: 14}}> <FaCheck/> </td>
                                          <td style={{fontSize: 14}}> {child?.price || 0} </td>
                                          {/* <td style={{fontSize: 14}}>{numberFormat(child?.totalPrice)}</td> */}
                                        </tr>
                                      ))
                                    ) : null
                                  }
                                </>
                                {/* <HistoryOrderChildren oIndex={index} children={e?.children}/> */}
                            </>
                          ))
                        }
                      </tbody>
                    </Table>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "start",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontSize: 16 }}>ລວມຕາມສະກູນເງິນ:</div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                        }}
                      >
                        <span style={{ fontSize: 16 }}>
                          {numberFormat(Location?.state?.state?.totalPrice ?? 0)} ₭
                        </span>
                        <span style={{ fontSize: 16 }}>
                          {numberFormat(Location?.state?.state?.sumPriceBaht ?? 0)}{" "}
                          ฿
                        </span>
                        <span style={{ fontSize: 16 }}>
                          {numberFormat(Location?.state?.state?.sumPriceUsd ?? 0)}{" "} $
                        </span>
                      </div>
                    </div>

                    <hr style={{ border: "1px solid #000" }} />

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      {Location?.state?.state?.cash > 0 && <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          fontSize: 14, fontWeight: 'bold'
                        }}
                      >
                        <span>ເງິນສົດ:</span>
                        <span>
                          {numberFormat(Location?.state?.state?.cash ?? 0)} {Location?.state?.state?.currency}
                        </span>
                      </div>}
                      {Location?.state?.state?.transfer > 0 && <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          fontSize: 14, fontWeight: 'bold'
                        }}
                      >
                        <span>ເງິນໂອນ:</span>
                        <span>
                          {numberFormat(Location?.state?.state?.transfer ?? 0)} {Location?.state?.state?.currency}
                        </span>
                      </div>}
                      {Location?.state?.state?.debt > 0 && <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          fontSize: 14, fontWeight: 'bold'
                        }}
                      >
                        <span>ຕີດຫນີ້:</span>
                        <span>
                          {numberFormat(Location?.state?.state?.debt ?? 0)} {Location?.state?.state?.currency}
                        </span>
                      </div>}

                      {/* {!shopData?.isBillNumber && <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          fontSize: 20, fontWeight: 'bold'
                        }}
                      >
                        <span>ຍອດເງິນລວມທັງໝົດ:</span>
                        <span>
                          {numberFormat(Location?.state?.state?.sumPrice ?? 0)} {Location?.state?.state?.currency}
                        </span>
                      </div>} */}

                      {
                        shopData?.isBillNumber==="bill_2" ?
                          <>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <span>ລວມເປັນບາດ :</span>
                              <b>
                                {numberFormat(Math.round((Location?.state?.state?.sumPrice / Location?.state?.state?.rateBaht ?? 0) * 10) / 10)} ບາດ
                              </b>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <span>ລວມເປັນໂດລາ :</span>
                              <b>
                                {numberFormat(Math.round((Location?.state?.state?.sumPrice / Location?.state?.state?.rateUsd ?? 0) * 10) / 10)} ໂດລາ
                              </b>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                fontSize: 20,
                                fontWeight: 'bold'
                              }}
                            >
                              <span>ລວມເປັນກີບ :</span>
                              <span>
                                {numberFormat(Location?.state?.state?.sumPrice ?? 0)} ກີບ
                              </span>
                            </div>
                          </>
                        : 
                        <>
                          
                        {/* <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              fontSize: 16, fontWeight: 'bold',
                            }}
                          >
                            <span>ຍອດເງິນລວມທັງໝົດ:</span>
                            <span>
                              {numberFormat(
                                getorder?.orderGroup?.totalPrice ??
                                Location?.state?.state?.totalPrice ??
                                0
                              )} ກີບ
                            </span>
                        </div> */}

                        {(
                        (Location?.state?.state?.discount ?? 0) > 0 ||
                        (Location?.state?.state?.discountManual ?? 0) > 0
                      ) && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            fontSize: 14,
                            fontWeight: "bold",
                            marginTop: 5,
                          }}
                        >
                          <span>ສ່ວນຫລຸດ:</span>
                          <span>
                            {(() => {
                              const manual = Location?.state?.state?.discountManual ?? 0;
                              const base = Location?.state?.state?.discount ?? 0;
                              if (manual > 0) {
                                const unit = Location?.state?.state?.discountType ? "₭" : "%";
                                return `${numberFormat(manual)} ${unit}`;
                              }
                              return `${numberFormat(base)} %`;
                            })()}
                          </span>
                        </div>
                      )}
                      
                        <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              fontSize: 20, fontWeight: 'bold',
                              color:"green",
                              marginTop: 5
                            }}
                          >
                            <span>ຍອດເງິນລວມທັງໝົດ:</span>
                            <span>
                              {numberFormat(Location?.state?.state?.sumPrice || 0)} ກີບ
                            </span>
                        </div>
                        </>
                      }

                      {/* {(() => {
                        const received = Location?.state?.state?.receivedMoney ?? 0;
                        const totalKip =
                          totals?.totalKip ?? Location?.state?.state?.sumPrice ?? 0;
                        const change =
                          Location?.state?.state?.change ?? received - totalKip;
                        return (
                          <p style={{ fontSize: 12 }}>
                            ເງິນທີ່ໄດ້ຮັບມາ {numberFormat(received)} ກີບ, ຄ່າເຄື່ອງ{" "}
                            {numberFormat(totalKip)} ກີບ, ເງິນທີ່ຕ້ອງຖອນกັບຄືນ{" "}
                            {numberFormat(change)} ກີບ
                          </p>
                        );
                      })()} */}

                      <p
                        style={{
                          fontSize: 12,
                          marginTop: 2,
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        {shopData?.descriptionPOSBill ??
                          "ຂອບໃຈລູກຄ້າທີ່ມາໃຊ້บໍລິການ"}
                      </p>

                    </div>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 8,
                  position: "absolute",
                  left: 0,
                  bottom: 0,
                  width: '100%',
                  padding: 20,
                  background: COLOR_WHITE
                }}
              >
                {/* //TODO: ປະຫວັດການຂາຍ_A4_btn */}
                <ReactToPrint
                  trigger={() => (
                    <CustomButton
                      background="transparent"
                      border={`1px solid ${APP_COLOR}`}
                      color={APP_COLOR}
                      fontweight="400"
                      width={100}
                      icon={<PrintIcon />}
                      height={42}
                      borderRadius={4}
                      title="A4"
                    />
                  )}
                  content={() => componentRef.current}
                />

                {!dataForRetrun?.length >= 1 ? (
                  <>
                    {/* //TODO: ປະຫວັດການຂາຍ_ຮັບບິນ_btn */}
                    <CustomButton
                      onClick={() => setShowModal(true)}
                      width={100}
                      height={42}
                      icon={<PrintIcon />}
                      borderRadius={4}
                      background={"green"}
                      title={"ຮັບບິນ"}
                    />
                    {Location?.state?.state?.status === "NOTYETPAID" ? (
                      <CustomButton
                        onClick={() => setShowUpdatePaid(true)}
                        width={100}
                        icon={<MdAttachMoney size={22} />}
                        height={42}
                        background={LINEAR_GRADIENT_BG}
                        borderRadius={4}
                        title=" ຈ່າຍເງີນ"
                      />
                    ) : (
                      ""
                    )}
                    {Location?.state?.state?.status === "COMPLETED" ||
                      Location?.state?.state?.status === "NOTYETPAID" ? (
                      <>
                        {/* //TODO: ປະຫວັດການຂາຍ_ສົ່ງຄືນທັງໝົດ_btn */}
                        {(isAdmin || hasEditBillPermission) && <CustomButton
                          onClick={() => setShowComfirmReturnAll(true)}
                          width={180}
                          height={42}
                          icon={<MdSettingsBackupRestore size={22} />}
                          background={LINEAR_GRADIENT_BG}
                          borderRadius={4}
                          title={width > 700 ? "ສົ່ງຄືນທັງໝົດ" : "ສົ່ງຄືນ"}
                        />}
                      </>
                    ) : (
                      ""
                    )}
                    {/* //TODO: ປະຫວັດການຂາຍ_ເເກ້ໄຂ_btn */}
                    {(shopSetting?.editOrderAfterSale && (isAdmin || hasEditBillPermission)) && <CustomButton
                      onClick={() =>
                        history.push("/sale_edit/limit/50/page/1", {
                          state: {
                            ...orderGroup,
                            orders: (ordergroup?.length ? ordergroup : orderGroup?.orders) || [],
                            discount: orderGroup?.discount ?? 0,
                            totalPrice: orderGroup?.totalPrice ?? 0,
                            discountManual: orderGroup?.discountManual ?? 0,
                            discountType: orderGroup?.discountType ?? true,
                            discountAmountApplied: orderGroup?.discountAmountApplied ?? 0,
                          },
                          isEdited: true,
                          isFromSale: true,
                        })
                      }
                      width={100}
                      icon={<AiFillEdit size={22} />}
                      height={42}
                      background={LINEAR_GRADIENT_BG}
                      borderRadius={4}
                      title="ເເກ້ໄຂ"
                    />}
                  </>
                ) : (
                  <>
                    <CustomButton
                      onClick={() => setShowConfirmReturnOrder(true)}
                      width={140}
                      disabled={dataForRetrun?.length >= 1 ? false : true}
                      height={42}
                      icon={<MdSettingsBackupRestore size={22} />}
                      background={
                        dataForRetrun?.length >= 1
                          ? LINEAR_GRADIENT_BG
                          : "gray"
                      }
                      borderRadius={4}
                      title={"ຄືນຈຳນວນທີ່ເລືອກ"}
                    />
                  </>
                )}

                <CustomButton
                  onClick={handleConfirmShipped}
                  width={140}
                  disabled={confirmShippLoading ? true : false}
                  height={42}
                  background={LINEAR_GRADIENT_BG}
                  borderRadius={4}
                  title="ຢືນຢັນຈັດສົ່ງ"
                />
              </div>
            </div>
          </>
        )}
      </div>

      <div
        style={{ width: "80mm", position: "absolute", top: "-9999px" }}
        ref={bill80Ref}
      >
        <BillforSale80
          Location={{
            ...Location,
            state: {
              ...Location?.state,
              state: {
                ...(Location?.state?.state || {}),
                rateBaht: getorder?.orderGroup?.rateBaht || Location?.state?.state?.rateBaht || 1,
                rateUsd: getorder?.orderGroup?.rateUsd || Location?.state?.state?.rateUsd || 1,
              },
            },
          }}
          ordergroup={ordergroup}
        />
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Body style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "80mm", padding: 4 }} ref={bill80Ref}>
            <BillforSale80
              Location={{
                ...Location,
                state: {
                  ...Location?.state,
                  state: {
                    ...(Location?.state?.state || {}),
                    rateBaht: getorder?.orderGroup?.rateBaht || Location?.state?.state?.rateBaht || 1,
                    rateUsd: getorder?.orderGroup?.rateUsd || Location?.state?.state?.rateUsd || 1,
                  },
                },
              }}
              ordergroup={ordergroup}
              shopData={shopData}
              prepareRate={prepareRate}
            />
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{ display: "flex", justifyContent: "center", gap: 10 }}
        >
          <CustomButton
            width={150}
            height={42}
            background={LINEAR_GRADIENT_BG}
            borderRadius={4}
            icon={<PrintIcon />}
            title={"Ethernet"}
            onClick={() => onPrintBill()}
          />
          <ReactToPrint
            trigger={() => (
              <CustomButton
                width={150}
                height={42}
                background={LINEAR_GRADIENT_BG}
                icon={<PrintIcon />}
                borderRadius={4}
                title={"Usb"}
              />
            )}
            content={() => bill80Ref.current}
          />
        </Modal.Footer>
      </Modal>

      <ComfirmModal
        showConfirmModal={showConfirmReturnOrder}
        handleCancel={() => setShowConfirmReturnOrder(false)}
        handleConfirm={_updateOrders}
        loadingConfirm={ordergroupLoadding || loadingreturnordergroup}
        title="ແຈ້ງເຕືອນ"
        text="ທ່ານຕອ້ງການສົ່ງຄືນສິນຄ້າທັງໝົດນີ້ຫຼືບໍ່!"
      />

      <ComfirmModal
        showConfirmModal={showComfirmReturnAll}
        handleCancel={() => setShowComfirmReturnAll(false)}
        handleConfirm={_ReturnOrderGroup}
        loadingConfirm={ordergroupLoadding || loadingreturnordergroup}
        title="ແຈ້ງເຕືອນ"
        text="ທ່ານຕອ້ງການສົ່ງຄືນບິນນີ້ບໍ!"
      />

      <Modal
        show={showUpdatePaid}
        onHide={() => setShowUpdatePaid(false)}
        centered
      >
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            height: "300px",
          }}
        >
          <div>
            <MdOutlineQuestionMark size={100} color="red" />
          </div>
          <div style={{ marginTop: "20px", fontSize: 20 }}>
            ທ່ານຕອ້ງການຈ່າຍເງີນໃບບິນນີ້ຫຼືບໍ່!
          </div>
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
          <CustomButton
            width={140}
            height={42}
            borderRadius={4}
            background="transparent"
            color="#3C169B"
            border="1px solid #3C169B "
            fontweight={400}
            title={"ຍົກເລີກ"}
            onClick={() => setShowUpdatePaid(false)}
          />
          &emsp;
          <CustomButton
            width={140}
            height={42}
            background={LINEAR_GRADIENT_BG}
            borderRadius={4}
            title={loadingUpdatePaid ? <Spinner /> : "OK"}
            onClick={() => _updatePaid()}
          />
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
